
import React, { Component } from 'react';
import { Form, message, Input, Modal, Radio } from 'antd';
import '../../../static/css/index.css'
import { addRole, updateRole } from '../../../apis/api'

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 },
};

class EditRole extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:''
    }
  }

  componentDidMount(){
    
    this.setState({access_token:sessionStorage.getItem('access_token')})

  }

  
  componentWillReceiveProps(nextProps) { 
    

  }

  // 点击取消按钮
  handleCancel = (e) => {
    this.props.cancelModal();
    this.props.form.resetFields();
  }

  // 增加、修改角色点击确定按钮
  handleOk = (e) => {
    let _this=this;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        values.access_token=_this.state.access_token;
        values.is_manage=values.is_manage===1?1:2
        if(_this.props.details.id){//修改
           values.id=_this.props.details.id;
           updateRole(values).then( (data)=> {
                if(data.code===0){
                    message.success('修改角色成功！');
                    _this.props.cancelModal();
                    _this.props.form.resetFields();
                    _this.props.getRoleList();

                }else{
                    
                    message.error(data.message);
        
              }
            });

        }else{//新增

            addRole(values).then( (data)=> {
                if(data.code===0){
                    message.success('新增角色成功！');
                    _this.props.cancelModal();
                    _this.props.form.resetFields();
                    _this.props.getRoleList();
                }else{
                    
                    message.error(data.message);
        
              }
            });

        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { details,visible } = this.props;

    return (

       <div className='editRole_form'>

        <Modal
          title={details&&details.id?'更新角色':'添加角色'}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确定"
          cancelText="取消"
        >

            <Form >
                
                {/* {details&&details.id?
                <div>
                 <Form.Item label="角色id" {...formItemLayout}>
                    {getFieldDecorator('id', {
                        initialValue:details&&details.id?details.id:''
                    })(
                        <Input disabled/>
                    )}
                 </Form.Item>

                 <Form.Item label="角色uuid" {...formItemLayout}>
                    {getFieldDecorator('uuid', {
                        initialValue:details&&details.uuid?details.uuid:''
                    })(
                        <Input disabled />
                    )}
                 </Form.Item>

                </div>:''} */}

                <Form.Item label="角色名称" {...formItemLayout}>
                    {getFieldDecorator('name', {
                        initialValue:details&&details.name?details.name:'',
                        rules: [{ required: true, message: '请输入角色名称!' }]
                    })(
                        <Input placeholder='请输入角色名称' />
                    )}
                </Form.Item>

                <Form.Item label="是否为管理员" {...formItemLayout}>
                    {getFieldDecorator('is_manage', {
                        initialValue:details&&details.is_manage?details.is_manage:''
                    })(
                        <Radio.Group>
                            <Radio value={1}>是</Radio>
                            <Radio value={2}>否</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>

                <Form.Item label="角色说明" {...formItemLayout}>
                    {getFieldDecorator('desc', {
                        initialValue:details&&details.desc?details.desc:''
                    })(
                        <Input placeholder='请输入角色说明' />
                    )}
                </Form.Item>

            </Form>
        </Modal>
             
       </div>
    );
  }
}

EditRole = Form.create({
   
})(EditRole);
export default EditRole;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/editRole.js